import {
	CurrencyDisplay,
	DateTime,
	H4Flow,
	TableCell,
	TableRow,
} from '@monthio/react-components'
import { ReportIcon } from './ReportIcon'
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Transaction } from '../../../types/budgetApi.types'

const StyledH4Flow = styled(H4Flow)`
	margin: 0;
	font-weight: 400;
`

export const TransactionRow = ({
	selectedTransactionId,
	transaction,
	onRowClick,
}: {
	selectedTransactionId?: string
	transaction: Transaction
	onRowClick?: (transaction: Transaction) => void
}): ReactElement => (
	<TableRow
		key={transaction.transactionId}
		onClick={() => onRowClick && onRowClick(transaction)}
	>
		<TableCell>
			<StyledH4Flow>
				<DateTime date={transaction.transactionDate} format="short" showYear />
			</StyledH4Flow>
		</TableCell>
		<TableCell>
			<StyledH4Flow>{transaction.cleanedText}</StyledH4Flow>
		</TableCell>
		<TableCell align="right">
			<StyledH4Flow>
				<CurrencyDisplay amount={Math.abs(transaction.amount)} />
			</StyledH4Flow>
		</TableCell>
		{onRowClick ? (
			<TableCell align="center">
				<ReportIcon
					isSelected={selectedTransactionId === transaction.transactionId}
					isReported={!!transaction.isReported}
				/>
			</TableCell>
		) : null}
	</TableRow>
)
